import * as React from 'react'
import { observer } from 'mobx-react'
import StartDateViewModel from '../../../StartDateViewModel'
import DateTimeEditorInput from 'jobs/questions/DateTime/components/DateTimeEditorInput'

interface StartDateEditorProps {
  vm: StartDateViewModel
}

/**
 * The StartDateEditor
 */
export default observer(function StartDateEditor({ vm }: StartDateEditorProps) {
  return (
    <DateTimeEditorInput
      vm={vm.dateVM}
      disabled={vm.disabled}
      onFocus={vm.step.onBecameActive}
      focus$={vm.step.becomeActive$}
    />
  )
})
